export const editorInit = function (
  exportValue: any,
  hasModel = false,
  hasOptionTranscription = false,
) {
  const height = () => {
    if (hasModel) return 370;
    if (hasOptionTranscription) return 500;
    return 285;
  };

  return {
    height: innerHeight - height(),
    language: "pt_BR",
    language_url: "/lang/pt_BR.js",
    menubar: "file",
    branding: false,
    plugins: [
      "export",
      "advlist",
      "autolink",
      "lists",
      "link",
      "image",
      "charmap",
      "preview",
      "anchor",
      "searchreplace",
      "visualblocks",
      "code",
      "fullscreen",
      "insertdatetime",
      "media",
      "code",
      "wordcount",
    ],
    toolbar:
      `undo redo | ${exportValue ? "export |" : ""} blocks | ` +
      "bold italic forecolor | alignleft aligncenter " +
      "alignright alignjustify | bullist numlist outdent indent | " +
      "removeformat |",
    menu: {
      file: {
        title: "Arquivo",
        items: "preview print",
      },
    },
    content_style:
      "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
  };
};
